import React, { useEffect, useState } from "react";
import { countryTr, countryOptions } from "../util/countryTr";
import { useHistory, useLocation } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import EdiText from "react-editext";

import {
  getUserProfile,
  blockUser,
  updateHostCoin,
  updateUserByAdmin,
  sureSor,
} from "../store/user/user.action";
import { setToast } from "../util/toast";
import girlImg from "../assets/img/female.png";
import api from "../util/panelApi";
import { fmt, img, Tabs } from "./Panel/kit";

/// 3 Kas: kullanicinin ajansi (yayinci / sahip / ortak) ve ajansin BD'si
const AjansBilgi = ({ userId }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!userId) return;
    api.agencyOfUser(userId).then((r) => setRows(r?.status ? r.rows || [] : []));
  }, [userId]);
  if (!rows) return null;
  if (!rows.length)
    return <div style={{ marginTop: 12, fontSize: 12.5, color: "var(--badu-sub)" }}>Ajans: yok</div>;
  return (
    <div style={{ marginTop: 12, display: "grid", gap: 6, textAlign: "left" }}>
      {rows.map((r, i) => {
        const aktif = r.state === "active";
        return (
          <div key={i} className="d-flex align-items-center" style={{ gap: 8, padding: "8px 10px", borderRadius: 12, border: "1px solid var(--badu-line)", opacity: aktif ? 1 : 0.55 }}>
            {r.agency.logo ? <img src={img(r.agency.logo)} alt="" onError={(e) => (e.target.style.display = "none")} style={{ width: 32, height: 32, borderRadius: 8, objectFit: "cover" }} /> : null}
            <div style={{ minWidth: 0, flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 13.5, color: "var(--badu-ink)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.agency.name}</div>
              <div style={{ fontSize: 11.5, color: "var(--badu-sub)" }}>
                {r.rol} · kod {r.agency.code}
                {r.bd ? ` · BD ${r.bd.name}` : ""}
                {!aktif ? ` · ${r.state === "left" ? "ayrıldı" : r.state}` : ""}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

/// Kullanici detay sayfasi — AYVO paneli.
const UserProflie = (props) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const id = location.state?.userId;
  const { userProfile } = useSelector((state) => state.user);

  useEffect(() => {
    if (id) dispatch(getUserProfile(id));
  }, [dispatch, id]);

  const isNumeric = (value) => /^\d+$/.test(value === "" ? 0 : value);

  const handleSaveCoin = (val) => {
    if (val < 0 || !isNumeric(val)) {
      setToast("error", "Geçersiz coin değeri");
      return;
    }
    props.updateHostCoin(val, userProfile._id);
    setToast("success", "Coin güncellendi");
  };

  const formatDate = (value) => {
    if (!value) return "—";
    const d = new Date(value);
    if (isNaN(d.getTime())) return value;
    return d.toLocaleDateString("tr-TR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const loginTypeLabel = (type) => {
    switch (Number(type)) {
      case 0:
        return "Hızlı giriş";
      case 1:
        return "Google";
      case 2:
        return "E-posta";
      case 3:
        return "Apple";
      case 4:
        return "Facebook";
      default:
        return "—";
    }
  };

  // sunucu: 0 = Android, 1 = iOS
  const platformLabel = (type) => {
    switch (Number(type)) {
      case 0:
        return "Android";
      case 1:
        return "iOS";
      default:
        return "—";
    }
  };

  const genderLabel = (g) => {
    if (!g) return "—";
    return g.toLowerCase() === "male" ? "Erkek" : "Kadın";
  };

  const value = (v) => (v === null || v === undefined || v === "" ? "—" : v);

  /// Tek alani kaydeder.
  const saveField = (field) => (val) => {
    const trimmed = `${val}`.trim();
    if (field === "uniqueId" && trimmed === "") {
      setToast("error", "Kullanıcı kodu boş olamaz");
      return;
    }
    props.updateUserByAdmin(userProfile._id, { [field]: trimmed });
  };

  /// Satir — duzenlenebilir ya da salt okunur.
  const Field = ({ label, value: val, field, options }) => (
    <div className="col-12 col-md-6 mb-3">
      <div className="badu-lbl">{label}</div>
      {field ? (
        options ? (
          <select
            className="form-control mt-1"
            value={val || ""}
            onChange={(e) => saveField(field)(e.target.value)}
            style={{ fontSize: "14px", fontWeight: 600, maxWidth: "260px" }}
          >
            {options.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        ) : (
          <EdiText
            type="text"
            value={val === "—" ? "" : String(val ?? "")}
            onSave={saveField(field)}
            saveButtonContent="Kaydet"
            cancelButtonContent="Vazgeç"
            editButtonContent="Düzenle"
            saveButtonClassName="btn btn-success btn-sm"
            cancelButtonClassName="btn btn-outline-primary btn-sm"
            editButtonClassName="btn btn-outline-primary btn-sm"
            viewProps={{
              style: {
                fontSize: "14.5px",
                fontWeight: 600,
                color: "var(--badu-ink)",
                wordBreak: "break-word",
              },
            }}
          />
        )
      ) : (
        <div
          style={{
            color: "var(--badu-ink)",
            fontSize: "14.5px",
            fontWeight: 600,
            marginTop: "3px",
            wordBreak: "break-word",
          }}
        >
          {val}
        </div>
      )}
    </div>
  );



  const [d, setD] = useState(null);
  const [coinOpen, setCoinOpen] = useState(false);
  const [coinVal, setCoinVal] = useState("");

  useEffect(() => {
    if (id) api.user360(id).then((r) => r?.status && setD(r));
  }, [id, userProfile?.coin]);

  // onay sormadan yasaklar (suresiz), sonra detayi yeniler
  const banDev = async (kind, value, mevcut) => {
    // yasak varsa ayni dugme yasagi kaldirir
    const r = mevcut ? await api.banRemove(mevcut._id) : await api.banAdd({ kind, value, reason: "Admin panelinden", days: 0 });
    if (!r?.status) window.alert(r?.message || "Olmadı.");
    api.user360(id).then((x) => x?.status && setD(x));
  };
  const vipAl = async () => {
    if (!window.confirm(`${userProfile?.name || "Bu kişinin"} VIP üyeliği şimdi bitirilsin mi?`)) return;
    const r = await api.vipRevoke(id);
    window.alert(r?.message || (r?.status ? "VIP kaldırıldı." : "Olmadı."));
    api.user360(id).then((x) => x?.status && setD(x));
  };
  const delUser = async () => {
    if (!window.confirm(`${userProfile?.name || "Bu hesap"} KALICI silinsin mi? Geri alınamaz.`)) return;
    const r = await api.userDelete(userProfile._id, userProfile.uniqueID);
    window.alert(r?.message || (r?.status ? "Hesap silindi." : "Silinemedi."));
    if (r?.status) history.goBack();
  };

  const age = (() => {
    if (!userProfile?.dob) return null;
    const b = new Date(userProfile.dob);
    if (isNaN(b.getTime())) return null;
    return Math.floor((Date.now() - b.getTime()) / 31557600000);
  })();

  const dt = (v) =>
    v ? new Date(v).toLocaleString("tr-TR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";

  const e = d?.economy, l = d?.levels, s = d?.social, a = d?.account;
  const purchased = e?.purchases?.reduce((t, p) => t + (p.amount || 0), 0) || 0;

  const Stat = ({ k, v }) => (
    <div className="mb-2">
      <div className="badu-lbl" style={{ marginBottom: 2 }}>{k}</div>
      <div style={{ fontSize: 14.5, fontWeight: 600, color: "var(--badu-ink)" }}>{v}</div>
    </div>
  );

  const btn = { borderRadius: 10, fontWeight: 600, fontSize: 13.5 };
  const [tab, setTab] = useState("genel");

  const Line = ({ k, v }) => (
    <div className="py-2" style={{ borderBottom: "1px solid var(--badu-line-soft)" }}>
      <div className="badu-lbl" style={{ marginBottom: 1 }}>{k}</div>
      <div style={{ fontSize: 13.5, fontWeight: 600, color: "var(--badu-ink)", wordBreak: "break-word" }}>{v}</div>
    </div>
  );

  const Box = ({ title, children, full }) => (
    <div className={full ? "col-12 mb-3" : "col-12 col-xl-6 mb-3"}>
      <div className="badu-tile" style={{ height: "100%" }}>
        <div className="badu-lbl mb-3" style={{ fontWeight: 700 }}>{title}</div>
        {children}
      </div>
    </div>
  );

  const None = ({ t = "Yok" }) => <div style={{ fontSize: 13.5, color: "var(--badu-sub)" }}>{t}</div>;

  return (
    <div className="row">
      {/* ------------------------------------------ sol: sabit profil karti */}
      <div className="col-12 col-lg-4 col-xl-3 mb-3">
        <div className="badu-tile" style={{ position: "sticky", top: 80, padding: 20 }}>
          <button className="btn btn-light btn-sm mb-2" style={btn} onClick={() => history.goBack()}>
            <i className="fa-solid fa-angles-left mr-1" /> Geri
          </button>
          <div className="text-center">
            <img
              src={userProfile?.image || girlImg}
              onError={(ev) => {
                ev.target.onerror = null;
                ev.target.src = girlImg;
              }}
              alt=""
              onClick={() => userProfile?.image && window.open(userProfile.image, "_blank")}
              style={{ width: 110, height: 110, objectFit: "cover", borderRadius: 28, border: "1px solid var(--badu-line)", cursor: "pointer" }}
            />
            <div style={{ fontSize: 19, fontWeight: 700, color: "var(--badu-ink)", marginTop: 10 }}>{value(userProfile?.name)}</div>
            <div style={{ fontSize: 13, color: "var(--badu-sub)" }}>#{value(userProfile?.uniqueID)}</div>
            <div className="mt-2 d-flex justify-content-center flex-wrap" style={{ gap: 6 }}>
              {userProfile?.isBlock ? <span className="badu-chip bad">Engelli{userProfile?.blockUntil ? ` · ${new Date(userProfile.blockUntil).toLocaleString("tr-TR")} bitiş` : " · kalıcı"}</span> : <span className="badu-chip ok">Aktif</span>}
              {userProfile?.isHost && <span className="badu-chip live">Yayıncı</span>}
              {a?.isLive ? <span className="badu-chip live">Canlı</span> : a?.isOnline ? <span className="badu-chip ok">Çevrimiçi</span> : null}
            </div>

            <AjansBilgi userId={userProfile?._id} />
            <div style={{ fontSize: 32, fontWeight: 700, color: "var(--badu-blue)", marginTop: 14, lineHeight: 1 }}>{fmt(userProfile?.coin)}</div>
            <div className="badu-lbl">coin</div>
          </div>

          {coinOpen ? (
            <div className="mt-3">
              <input className="form-control mb-2" autoFocus value={coinVal} onChange={(ev) => setCoinVal(ev.target.value.replace(/\D/g, ""))} placeholder="Yeni bakiye" />
              <div className="d-flex" style={{ gap: 6 }}>
                <button className="btn btn-success btn-block m-0" style={btn} onClick={() => { handleSaveCoin(coinVal); setCoinOpen(false); }}>Kaydet</button>
                <button className="btn btn-light btn-block m-0" style={btn} onClick={() => setCoinOpen(false)}>Vazgeç</button>
              </div>
            </div>
          ) : (
            <div className="mt-3 d-grid" style={{ display: "grid", gap: 8 }}>
              <button className="btn btn-primary" style={btn} onClick={() => { setCoinVal(String(userProfile?.coin ?? 0)); setCoinOpen(true); }}>
                <i className="fa fa-coins mr-1" /> Coin ekle / düş
              </button>
              <button className="btn btn-outline-primary" style={btn} onClick={() => history.push({ pathname: "/admin/user/history", state: { userId: id } })}>
                <i className="fa fa-history mr-1" /> Coin geçmişi
              </button>
              <button
                className={`btn ${userProfile?.isBlock ? "btn-success" : "btn-outline-danger"}`}
                style={btn}
                onClick={() => {
                  if (userProfile?.isBlock) {
                    if (window.confirm("Engel kaldırılsın mı?")) props.blockUser(userProfile);
                  } else {
                    // sunucu sebepsiz engellemez: sebep sor
                    const sebep = window.prompt("Engelleme sebebi (en az 3 harf):", "");
                    if (sebep === null) return;
                    const saat = sureSor();
                    if (saat !== null) props.blockUser(userProfile, sebep, saat);
                  }
                }}
              >
                <i className={`fa ${userProfile?.isBlock ? "fa-unlock" : "fa-ban"} mr-1`} /> {userProfile?.isBlock ? "Engeli kaldır" : "Engelle"}
              </button>
              <button className="btn btn-danger" style={btn} onClick={delUser}>
                <i className="fa fa-trash mr-1" /> Hesabı sil
              </button>
            </div>
          )}

          <div className="mt-3">
            <Line k="E-posta" v={value(userProfile?.email)} />
            <Line k="Giriş" v={`${loginTypeLabel(userProfile?.loginType)} · ${platformLabel(userProfile?.platformType)}`} />
            <Line k="Ülke" v={countryTr(userProfile?.country)} />
            <Line k="Kayıt" v={formatDate(userProfile?.createdAt)} />
            <Line k="Son görülme" v={dt(a?.lastSeenAt || userProfile?.lastLogin)} />
          </div>
        </div>
      </div>

      {/* ------------------------------------------ sag: sekmeler */}
      <div className="col-12 col-lg-8 col-xl-9">
        <Tabs
          value={tab}
          onChange={setTab}
          tabs={[
            ["genel", "Genel"],
            ["ekonomi", "Ekonomi"],
            ["sosyal", "Sosyal"],
            ["cihaz", "Cihaz"],
            ["hareket", `Hareketler${d ? ` (${d.recent.length})` : ""}`],
          ]}
        />
        {!d ? (
          <div className="badu-empty mt-3">Detaylar yükleniyor…</div>
        ) : (
          <div className="row mt-3">
            {tab === "genel" && (
              <>
                <Box title="Profil bilgileri · Düzenle'ye basıp değiştir" full>
                  <div className="row">
                    <Field label="Ad" value={value(userProfile?.name)} field="name" />
                    <Field label="Kullanıcı kodu" value={value(userProfile?.uniqueID)} field="uniqueId" />
                    <Field label="Hakkında" value={value(userProfile?.bio)} field="bio" />
                    <Field label="Ülke" value={(userProfile?.country || "").toLowerCase()} field="country" options={countryOptions(userProfile?.country)} />
                    <Field
                      label="Yönetim rütbesi (uygulamada rozet + çerçeve)"
                      value={userProfile?.staffRank || ""}
                      field="staffRank"
                      options={[
                        { value: "", label: "Yok" },
                        { value: "admin", label: "Admin" },
                        { value: "sa_assistant", label: "Super Admin Asistanı" },
                        { value: "superadmin", label: "Super Admin" },
                        { value: "manager", label: "Manager" },
                      ]}
                    />
                    {userProfile?.staffRank && (
                      <Field
                        label="Yönetim bölgesi (yalnız bu bölgeyi görür ve yönetir)"
                        value={userProfile?.staffRegion || ""}
                        field="staffRegion"
                        options={[
                          { value: "", label: "Hepsi" },
                          { value: "ar", label: "Arap ülkeleri (MENA)" },
                          { value: "tr", label: "Türkiye" },
                          { value: "pk", label: "Pakistan" },
                        ]}
                      />
                    )}
                    <Field
                      label="Şifreli odalara şifresiz giriş"
                      value={String(userProfile?.lockBypass) === "true" ? "true" : "false"}
                      field="lockBypass"
                      options={[
                        { value: "false", label: "Kapalı" },
                        { value: "true", label: "Açık" },
                      ]}
                    />
                    <Field label="Telefon" value={value(userProfile?.mobileNo)} field="mobileNo" />
                    <Field
                      label="Cinsiyet"
                      value={String(userProfile?.gender || "").toLowerCase() === "male" ? "Male" : "Female"}
                      field="gender"
                      options={[
                        { value: "Male", label: "Erkek" },
                        { value: "Female", label: "Kadın" },
                      ]}
                    />
                    <Field label="Doğum tarihi" value={`${formatDate(userProfile?.dob)}${age ? ` (${age} yaş)` : ""}`} />
                  </div>
                </Box>
                <Box title="Seviyeler & VIP" full>
                  <div className="d-flex flex-wrap" style={{ gap: 32 }}>
                    <Stat k="Zenginlik" v={l ? `${l.wealth} · ${fmt(l.spent)} coin harcadı` : "—"} />
                    <Stat k="Çekicilik" v={l ? `${l.charm} · ${fmt(l.earned)} coin aldı` : "—"} />
                    <Stat k="Aktivite" v={l?.activity ?? "—"} />
                    <div>
                      <Stat k="VIP" v={d.vip ? `VIP${d.vip.level} · ${formatDate(d.vip.expiresAt)}` : "Yok"} />
                      {d.vip && (
                        <button type="button" className="btn btn-sm btn-outline-danger mt-1" onClick={vipAl}>
                          VIP'yi kaldır
                        </button>
                      )}
                    </div>
                    <Stat k="Aylık kart" v={s.cards.length ? s.cards.map((c) => c.key).join(", ") : "Yok"} />
                  </div>
                </Box>
              </>
            )}

            {tab === "ekonomi" && (
              <>
                <Box title="Bakiye">
                  <Line k="Coin" v={fmt(e.coin)} />
                  {e.hostCoin !== null && <Line k="Yayıncı hesabı coin" v={fmt(e.hostCoin)} />}
                  <Line k="Oyun coini" v={fmt(e.gameCoin)} />
                  <Line k="Satın aldığı coin (toplam)" v={fmt(e.purchasedCoin)} />
                  <Line k="Gönderdiği hediye" v={`${fmt(e.giftSent.coin)} coin · ${e.giftSent.n} kez`} />
                  <Line k="Aldığı hediye" v={`${fmt(e.giftReceived.coin)} coin · ${e.giftReceived.n} kez`} />
                </Box>
                <Box title={`Satın almalar${purchased ? ` · toplam $${fmt(purchased)}` : ""}`}>
                  {e.purchases.length ? (
                    <>
                      {e.purchases.map((p) => (
                        <Line key={p._id} k={p._id === "ios" ? "iPhone" : "Android"} v={`${p.n} işlem · $${fmt(p.amount)} · ${fmt(p.coin)} coin`} />
                      ))}
                      {e.recentPurchases.map((p) => (
                        <Line key={p._id} k={dt(p.createdAt)} v={`${p.productId} · ${fmt(p.coin)} coin`} />
                      ))}
                    </>
                  ) : (
                    <None t="Hiç satın alma yok" />
                  )}
                </Box>
                <Box title="Coin hareketleri türe göre" full>
                  {e.byType.length ? e.byType.map((t, i) => <Line key={i} k={`${t.label} · ${t.income ? "gelen" : "giden"}`} v={`${fmt(t.coin)} coin · ${t.n} kez`} />) : <None t="Hareket yok" />}
                </Box>
              </>
            )}

            {tab === "sosyal" && (
              <>
                <Box title="Takip & aile">
                  <Line k="Takipçi" v={fmt(s.followers)} />
                  <Line k="Takip ettiği" v={fmt(s.following)} />
                  <Line k="Onu engelleyen" v={fmt(s.blockedBy)} />
                  <Line k="Aile" v={s.family ? `${s.family.name} (Lv ${s.family.level || 1})` : "Yok"} />
                  <Line k="Evlilik" v={s.marriage ? `${s.marriage.partner} · ${formatDate(s.marriage.since)}` : "Yok"} />
                  <Line k="Davet eden" v={s.invitedBy || "—"} />
                  <Line k="Davet ettiği" v={fmt(s.invitedCount)} />
                </Box>
                <Box title="İlişkiler, koruma, fan kulübü">
                  {s.relations.map((r, i) => (
                    <Line key={"r" + i} k={REL[r.type] || r.type} v={`${r.with} · ${formatDate(r.since)}`} />
                  ))}
                  {s.guardians.map((g, i) => (
                    <Line key={"g" + i} k={g.role === "koruyucusu" ? `${g.other} yayıncısının koruyucusu` : `Koruyucusu: ${g.other}`} v={`Seviye ${g.level}`} />
                  ))}
                  {s.fans.map((f, i) => (
                    <Line key={"f" + i} k={f.role === "fanı" ? `${f.other} yayıncısının fanı` : `Fanı: ${f.other}`} v={formatDate(f.expiresAt)} />
                  ))}
                  {!s.relations.length && !s.guardians.length && !s.fans.length && <None />}
                </Box>
                <Box title="Sesli odaları" full>
                  {s.rooms.length ? s.rooms.map((r) => <Line key={r._id} k={`${r.title || "Oda"}${r.mode === "game" ? " (oyun)" : ""}`} v={`${r.isActive ? "Açık" : "Kapalı"} · ${fmt(r.totalGiftCoin)} coin`} />) : <None />}
                </Box>
              </>
            )}

            {tab === "cihaz" && (
              <>
                <Box title="Cihaz">
                  <Line k="Platform" v={a.platform} />
                  <Line k="Cihaz kimliği" v={a.deviceId || "—"} />
                  <Line k="Son IP" v={a.lastIp || "—"} />
                  <div className="d-flex mt-3" style={{ gap: 8 }}>
                    <button className="btn btn-sm btn-outline-danger" disabled={!a.deviceId} onClick={() => banDev("device", a.deviceId, d.security.bans.find((b) => b.kind === "device" && b.value === a.deviceId))}>{d.security.bans.find((b) => b.kind === "device" && b.value === a.deviceId) ? "Cihazı yasağını kaldır" : "Cihazı engelle"}</button>
                    <button className="btn btn-sm btn-outline-danger" disabled={!a.lastIp} onClick={() => banDev("ip", a.lastIp, d.security.bans.find((b) => b.kind === "ip" && b.value === a.lastIp))}>{d.security.bans.find((b) => b.kind === "ip" && b.value === a.lastIp) ? "IP yasağını kaldır" : "IP engelle"}</button>
                    <button className="btn btn-sm btn-outline-primary" onClick={async () => { const r = await api.gifGrant(id, 30); window.alert(r?.message || (r?.status ? "Verildi" : "Olmadı")); }}>GIF profil ver (30 gün)</button>
                  </div>
                </Box>
                <Box title="Cihaz / IP yasağı">
                  {d.security.bans.length ? (
                    d.security.bans.map((b, i) => <Line key={i} k={b.kind === "device" ? "Cihaz yasaklı" : "IP yasaklı"} v={`${b.reason || ""} ${b.expiresAt ? "· " + formatDate(b.expiresAt) : "· süresiz"}`} />)
                  ) : (
                    <None t="Yasak yok. Yasaklamak için: Cihaz / IP yasağı sayfası." />
                  )}
                </Box>
              </>
            )}

            {tab === "hareket" && (
              <Box title="Son hareketler" full>
                {d.recent.length ? (
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>Tarih</th>
                        <th>Tür</th>
                        <th>Kiminle</th>
                        <th style={{ textAlign: "right" }}>Coin</th>
                      </tr>
                    </thead>
                    <tbody>
                      {d.recent.map((h, i) => (
                        <tr key={i}>
                          <td>{dt(h.at)}</td>
                          <td>{h.type}</td>
                          <td>{h.with || "—"}</td>
                          <td style={{ textAlign: "right", fontWeight: 700, color: h.income ? "#059669" : "#DC2626" }}>
                            {h.income ? "+" : "−"}
                            {fmt(h.coin)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <None t="Hareket yok" />
                )}
              </Box>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const REL = { best_friend: "En iyi arkadaş", brother: "Erkek kardeş", sister: "Kız kardeş", cp: "CP" };

export default connect(null, { blockUser, updateHostCoin, updateUserByAdmin })(UserProflie);
